<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows" v-if="!editMode">
          <v-card color="grey lighten-4" class="pt-3 pl-3 pr-3 pb-1 elevation-0">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <h2 class="body-3 mb-0 bold">Detail obchodu</h2>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Datum:</p> <strong>lorem</strong>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Klient:</p> <strong>lorem</strong>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>

          <v-card color="grey lighten-4" class="pt-3 pl-3 pr-3 mt-4 pb-1 elevation-0">
            <v-card-text>
              <v-layout row wrap class="mt-3">
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Produkt:</p> <strong>lorem</strong>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Cena/ks / Cena při fixaci:</p> <strong>lorem</strong>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Počet:</p> <strong>lorem</strong>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Kredity:</p> <strong>lorem</strong>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-flex xs12 sm6 offset-sm6 md3 offset-md9>
                  <p class="mb-1"><span class="grey--text caption">Celkem kreditů:</span> <strong>9</strong></p>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>

          <v-card-actions class="mt-4">
            <v-btn color="primary" v-if="!editMode" @click="editModeClick" class="elevation-0"><v-icon small class="mr-2">edit</v-icon>Upravit</v-btn>
          </v-card-actions>
        </div>

        <div class="gui-flex gui-flex-rows" v-else>
          <v-card color="grey lighten-4" class="pt-3 pl-3 pr-3 pb-1 elevation-0">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <h2 class="body-3 mb-0 bold">Detail obchodu</h2>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-flex xs12 sm6>
                  <v-text-field label="Datum" class="mx-2"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="Klient" class="mx-2"></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>

          <v-card color="grey lighten-4" class="pt-3 pl-3 pr-3 mt-4 pb-1 elevation-0">
            <v-card-text>
              <v-layout row wrap class="mt-3">
                <v-flex xs12 sm6 md3>
                  <v-text-field label="Produktí" class="mx-2"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field label="Cena/ks (cena fixace)" class="mx-2"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field label="Počet" class="mx-2"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field label="Kredity" class="mx-2"></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>

          <v-card-actions class="mt-4">
            <v-btn color="primary" @click="edit" class="elevation-0"><v-icon small class="mr-2">save</v-icon>Uložit</v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
import RocniBonusy from '@/pages/Klienti/RocniBonusy'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      editMode: false
    }
  },
  mounted: function() {
    window.MenuListener.show();
  },
  methods: {
    editModeClick () {
      this.editMode = true
    },
    edit () {
      this.editMode = false
    }
  },
  components: {
    RocniBonusy
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Klienti/ObchodyProvizeDetail.vue